import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'

const TitleBin = ({ name, no, page }) => (
  <Wrapper>
    <WrapperNo active={no === page}>
      <span style={{ color: 'white' }}>{no}</span>
    </WrapperNo>

    <TypographyEx variant="h6" active={no === page}>
      {name}
    </TypographyEx>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 30px 0px 15px 0px;
`

const WrapperNo = styled.div`
  background-color: #b8b8b8;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;

  ${(props) => props.active && `background-color: #6ebf4b;`}
`

const TypographyEx = styled(Typography)`
  font-weight: bold;
  color: #b8b8b8 !important;

  ${(props) => props.active && `color: #6ebf4b !important;`}

  @media (min-width: 320px) and (orientation: portrait) {
    font-size: 0.75rem !important;
  }

  @media (min-width: 375px) and (max-height: 667px) and (orientation: portrait) {
    font-size: 0.75rem !important;
  }

  @media (min-width: 414px) and (max-height: 736px) and (orientation: portrait) {
    font-size: 0.75rem !important;
  }

  @media (min-width: 375px) and (max-width: 812px) and (orientation: portrait) {
    font-size: 0.75rem !important;
  }

  @media (min-width: 320px) and (orientation: portrait) {
    font-size: 0.75rem !important;
  }
`

TitleBin.propTypes = {
  name: PropTypes.string.isRequired
}

export default TitleBin



// WEBPACK FOOTER //
// ./src/components/TitleBin/index.js